module.exports = __webpack_public_path__ + "img/DE00452.7203680a.webp";